import { useMutation, useQueryClient } from 'react-query';
import { InsurancePolicy } from '@advisory-report/src/types/AdvisoryReport';
import { getUseInsurancePolicyQkey } from '@parties/src/features/detail/api/insurance-policies/getInsurancePolicyById';
import { getUseInsurancePolicyPackageQkey } from '@parties/src/features/detail/api/insurance-policies/getInsurancePolicyPackageById';
import { wgApi } from '../../../../../app/src/features/api/wgApi';

interface PatchParams {
  partyId: string;
  sessionId: string;
  payload: Partial<InsurancePolicy>;
}

export const putInsurancePolicyForSimulation = async ({
  partyId,
  sessionId,
  payload,
}: PatchParams) => {
  const path = `/v1/api/parties/${partyId}/simulations/${sessionId}/insurance-policies`;
  const { data, isError } = await wgApi.put(path, payload);
  if (isError) throw new Error(JSON.stringify(data));
  return data;
};

export const usePutInsurancePolicyForSimulation = () => {
  const queryClient = useQueryClient();
  return useMutation(putInsurancePolicyForSimulation, {
    onMutate: async ({ payload }) => {
      const queryKey = getUseInsurancePolicyQkey({
        insurancePolicyId: payload.id || '',
      });
      await queryClient.cancelQueries(queryKey);

      const prevData = queryClient.getQueryData<InsurancePolicy>(queryKey);

      queryClient.setQueryData(queryKey, payload);

      return prevData;
    },
    onError: (_, { payload }, context) => {
      const queryKey = getUseInsurancePolicyQkey({
        insurancePolicyId: payload.id || '',
      });
      if (context) queryClient.setQueryData(queryKey, context);
    },
    onSettled: (_, __, { payload, partyId }) => {
      const queryKey = getUseInsurancePolicyQkey({
        insurancePolicyId: payload.id || '',
      });
      queryClient.invalidateQueries(queryKey);
      if (payload.policy_package_id) {
        queryClient.invalidateQueries(
          getUseInsurancePolicyPackageQkey({
            partyId,
            packageId: payload.policy_package_id,
          }),
        );
      }
    },
  });
};
